import { Component, HostListener, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Menu, NavService } from "src/app/shared/services/nav.service";
import { SwitcherService } from "src/app/shared/services/switcher.service";

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss']
})
export class PublicLayoutComponent implements OnInit {
  public menuItems!: Menu[];
  public mode!: string;

  constructor(
    public SwitcherService: SwitcherService,
    public navServices: NavService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.navServices.items.subscribe((menuItems: any) => {
      this.menuItems = menuItems;
    });
  }
  ngOnInit() {
    document.querySelector('.slide-leftRTL')?.classList.add('d-none');
    document.querySelector('.slide-rightRTL')?.classList.add('d-none');

    this.router.events.subscribe((event) => {
      console.log('Event =>', event);

      const childRoute = this.route.firstChild;
      if (childRoute) {
        childRoute.data.subscribe((data) => {
          console.log('Data => ', data);
          this.mode = data['mode'] ?? '';
        });
      }
    });
  }

  ngOnDestroy() {
    location.reload();
  }
  scrolled: boolean = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.scrolled = window.scrollY > 74;
  }
}
